import { Box } from '@mui/material';
import NavBar from './layout/NavBar';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ListadoEmpresas from './empresas/ListadoEmpresas';
import AgregarEmpresa from './empresas/AgregarEmpresa';
import VistaEmpresa from './empresas/VistaEmpresa';
import { ToastBar, Toaster } from 'react-hot-toast';
import CarruselEmpresas from './componentes/CarruselEmpresas';
import Test from './empresas/test';
import { useState } from 'react';
import ListadoBorradores from './empresas/ListadoBorradores';
import AgregarOrganismo from './empresas/AgregarOrganismo';
import VistaOrganismo from './empresas/VistaOrganismo';
import ListadoOrganismos from './empresas/ListadoOrganismos';
import ListadoBorradoresOrganismos from './empresas/ListadoBorradoresOrganismos';
import Index from './empresas/Index';
import CarruselOrganismos from './componentes/CarruselOrganismos';

function App() {
  const [busqueda, setBusqueda] = useState('');
  const [estado, setEstado] = useState('');
  const [actividad, setActividad] = useState('');
  const handleSearch = (val) => {
    setBusqueda(val);
  }

  const handleFilterEstado = (val) => {
    setEstado(val);
  }

  const handleActividad = (val) => {
    setActividad(val);
  }

  const CustomToast = ({ toast }) => (
    <ToastBar
      toast={toast}

      style={{
        ...toast.style,
        animation: toast.visible ? 'custom-enter 1s ease' : 'custom-exit 1s ease',
      }}
    />
  )
  return (
    <BrowserRouter>
      <Box sx={{ width: '100%', height: '100%' }} className="App">
        <Toaster
          duration={3000}
          position="top-right"
          containerStyle={{
            bottom: 100
          }}
        >
          {(t) => <CustomToast key={t.id} toast={t} />}
        </Toaster>


        <NavBar handleSearch={handleSearch} handleFilterEstado={handleFilterEstado} handleActividad={handleActividad} />
        <Routes>
          <Route path="/" exact element={<Index />} />
          <Route path="/index" exact element={<Index />} />
          <Route path="/empresas" exact element={<ListadoEmpresas busqueda={busqueda} estado={estado} actividad={actividad} />} />
          <Route path="/organismos" exact element={<ListadoOrganismos busqueda={busqueda} estado={estado} actividad={actividad} />} />
          <Route path="/agregar" exact element={<AgregarEmpresa />} />
          <Route path="/agregar_organismo" exact element={<AgregarOrganismo />} />
          <Route path="/empresas/:nombre_empresa" element={<VistaEmpresa />} />
          <Route path="/organismos/:nombre_empresa" element={<VistaOrganismo />} />
          <Route path="/carrusel-empresas" exact element={<CarruselEmpresas />} />
          <Route path="/carrusel-organismos" exact element={<CarruselOrganismos isOrganismo={true} />} />
          <Route path="/empresas_no_publicadas" exact element={<ListadoBorradores />} />
          <Route path="/organismos_no_publicados" exact element={<ListadoBorradoresOrganismos />} />
          <Route path="/test" exact element={<Test />} />
        </Routes>
      </Box>
    </BrowserRouter>
  );
}

export default App;
